// extracted by mini-css-extract-plugin
export default {"div":"info_div__CAGY5","slideUp":"info_slideUp__bzQQ+"};